import React, { useContext } from 'react';
import { Breadcrumb, Layout, Menu, theme, Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { Context } from '../context';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
const { Header, Content, Sider } = Layout;

// Получаем роль текущего пользователя из localStorage
const getCurrentUserRole = () => {
  try {
    const authUser = localStorage.getItem('auth_user');
    if (authUser) {
      const user = JSON.parse(authUser);
      return user.role || 1;
    }
  } catch (error) {
    console.error('Error getting user role:', error);
  }
  return 1; // По умолчанию обычный пользователь
};


export const MainLayout = ({ children, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(Context);
  const { person } = useParams();

  const userRole = getCurrentUserRole();
  const isAdminOrSuperAdmin = userRole === 2 || userRole === 3;

  const items1 = [{
    key: 1,
    label: `Задачи`,
    onClick: () => navigate('/'),
  },
  // Вкладка "Исполнители" только для админов и супер-админов
  isAdminOrSuperAdmin && {
    key: 2,
    label: `Исполнители`,
    onClick: () => navigate('/people'),
  },
  // Вкладка "Тестовые лекции" только для админов и супер-админов
  isAdminOrSuperAdmin && {
    key: 3,
    label: `Тестовые лекции`,
    onClick: () => navigate('/test-lectures'),
  },
    // alumniData && {
    //   key: 2,
    //   label: `${person}`,
    //   onClick: () => navigate(`/${person}`),
    // },
    // projectData && {
    //   key: 3,
    //   label: `${projectData.name}`,
    //   onClick: () => navigate(`/@${alumniHandle}/${projectData._id}`),
    // },
  ].filter(Boolean);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  return (
    <Layout>
      <div
        style={{
          padding: '16px 24px',
          // backgroundColor: '#0000002d',
          backdropFilter: 'blur(10px)',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          color: '#000',
        }}
        className="_f _fm _fgap2"
      >
        <div className="global-logo _fc _fgap1">


          <h1 style={{ color: '#000' }}>Перевод лекций</h1>
        </div>
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname === '/people' ? '2' : '1']}
          items={items1}
          style={{
            flex: 1,
            minWidth: 0,
            backgroundColor: 'transparent',
          }}
        />
        {onLogout && (
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={onLogout}
            style={{ marginLeft: 'auto' }}
          >
            Выход
          </Button>
        )}
      </div>
      <Layout>

        <Layout
          style={{
            // padding: '24px 0',
          }}
        >


          {/* <div style={{ padding: '0 24px' }}>
            <Breadcrumb
              // items={[
              //   {
              //     title: 'Home',
              //   },
              //   {
              //     title: 'List',
              //   },
              //   {
              //     title: 'App',
              //   },
              // ]}
              style={{
                margin: '16px 0',
              }}
            />
          </div> */}


          <Content
            style={{
              padding: '0 20px ',
              margin: 0,
              minHeight: 280,
              // background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};
